import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Stack,
  Button,
  IconButton,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Paper,
  CircularProgress,
  Popover,
  Typography,
  Divider,
  MenuItem,
  Tooltip,
} from '@mui/material'
import client from '../common/client'
import AceEditor from 'react-ace'
import 'brace/ext/searchbox'
import 'ace-builds/src-noconflict/mode-java'
import 'ace-builds/src-noconflict/theme-github'
import toast, { Toaster } from 'react-hot-toast'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import DeviceHubIcon from '@mui/icons-material/DeviceHub'
import SettingsIcon from '@mui/icons-material/Settings';
import JavascriptIcon from '@mui/icons-material/Javascript';
import LanguageIcon from '@mui/icons-material/Language';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CodeIcon from '@mui/icons-material/Code';
import HistoryIcon from '@mui/icons-material/History';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const menu_list = [
  {
    name: 'block',
    icon: <DeviceHubIcon />,
    tooltip: 'Block Editor',
  },
  {
    name: 'setting',
    icon: <SettingsIcon />,
    tooltip: 'Screen Setting',
  },
  {
    name: 'common',
    icon: <JavascriptIcon />,
    tooltip: 'Common Code',
  },
  {
    name: 'language',
    icon: <LanguageIcon />,
    tooltip: 'Multi Language Setting',
  },
  {
    name: 'cloud',
    icon: <CloudDoneIcon />,
    tooltip: 'Figma Cloud',
  },
  {
    name: 'history',
    icon: <HistoryIcon />,
    tooltip: 'Edit History',
  },
]
const RightTool = props => {
  const navigate = useNavigate();

  return (
    <Box sx={{ width: '100%', height: '100%', textAlign: 'center' }}>
      <Toaster position='bottom-center' reverseOrder={false} />
      <Stack mt={2} spacing={1}>
        {menu_list.map(m =>
          <Tooltip
            interactive
            enterDelay={500}
            key={m.name}
            title={
              <Box>
                {m.tooltip}
                <IconButton color='secondary'>
                  <HelpOutlineIcon
                    onClick={() => {
                      alert(m.help)
                    }}
                  />
                </IconButton>
              </Box>
            }
          >
            <IconButton color='secondary' onClick={() => { props.clickRightTool(m.name) }}>
              {m.icon}
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </Box>
  )
}

export default RightTool
